skrilla.service('constantsService', function() {

    function getMarketingCategories(){
        return [
            "SignUp",
            "Pickem",
            "Pickle",
            "Factored",
            "Shark",
            "StingRay",
            "JellyFish",
            "Pelican",
            "Donkey",
            "Bunny",
            "VIP",
            "KingPickle"
        ];
    }

    function getMarketingCategoriesForQuery(){
        return {
                SignUp: false,
                Pickem: false,
                Pickle: false,
                Factored: false,
                Shark: false,
                StingRay: false,
                JellyFish: false,
                Pelican: false,
                Donkey: false,
                Bunny: false,
                VIP: false,
                KingPickle: false
        };
    }

    function getVerificationStatuses(){
        return ["UNVERIFIED", "IN_PROGRESS", "PENDING_REVIEW", "VERIFIED", "VERIFIED_ADMIN", "ERROR_OCCURRED", "FAILED"];
    }

    function getAustralianStates(){
        return ["QLD", "NSW", "VIC", "SA", "WA", "TAS", "NT", "ACT"];
    }

    function getPaymentProviderLabels() {
        return {
            SKRILL: "Skrill",
            MERCHANT_WARRIOR: "Credit Card",
            MERCHANT_WARRIOR_PAY_ID: "Pay Id",
            POLI: "Poli",
            PAYMENT_IQ: "Payment IQ",
            MANUAL: "Manual",
            MERCHANT_WARRIOR_GOOGLE_PAY:  "Google Pay",
            MERCHANT_WARRIOR_APPLE_PAY: "Apple Pay",
            WITHDRAWAL_BOUNCE_BACK: "Withdrawal Bounce Back"
        };
    }
    function getPaymentProviders() {
        return Object.fromEntries( Object.keys(getPaymentProviderLabels()).map(key => [key, false]));
    }

    function getUsersPageKey(){return "users"}

    return {
        getMarketingCategories,
        getMarketingCategoriesForQuery,
        getAustralianStates,
        getVerificationStatuses,
        getPaymentProviderLabels,
        getPaymentProviders,
        getUsersPageKey
    };
});
